// extracted by mini-css-extract-plugin
export default {"profileWrapper":"Profile_profileWrapper__9k7uy","headerWrapper":"Profile_headerWrapper__-nD3Z"};